import styled from 'styled-components';
import { Header } from '../../header.js';
export const PageHeader = styled(Header).attrs(() => ({ size: 'xl' })).withConfig({ displayName: "brc-sc-PageHeader", componentId: "brc-sc-1u76bhb" }) `
  flex-basis: 100%;
  width: 100%;
  margin-top: 32px;
  margin-bottom: 16px;
  text-transform: capitalize;
`;
//# sourceMappingURL=index.js.map